<template>
  <div>
    <div class="clear"></div>
    <!-- Content
    =============================================-->
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <!-- Page Title
          =============================================-->
          <!-- <section id="page-title">
            <div class="container clearfix">
              <h1>วิธีเช่าชุด</h1>
            </div>
          </section>-->
          <h1
            style="font-size: 48px ; font-weight: 500; text-align:left; padding-bottom 60px; padding-top: 50px; "
          >วิธีเช่าชุด</h1>
          <!-- #page-title end -->

          <!-- Post Content
          =============================================-->
          <div
            class="postcontent nobottommargin clearfix row"
            style="width:100% !important; margin: auto;"
          >
            <div class="row" style="text-align:center;">
              <div class="col-lg-12 col-md-12 col-12">
                <img
                  :src="getFullPath('how_to_rent_1.png')"
                  style="width: 600px; margin-left: auto; margin-right:auto; text-align:center;"
                />
              </div>
            </div>

            <div class="row" style="text-align:center;">
              <div class="col-lg-12 col-md-12 col-12">
                <img
                  :src="getFullPath('how_to_rent_2.png')"
                  style="width: 600px; margin-left: auto; margin-right:auto; text-align:center;"
                />
              </div>
            </div>

           
          </div>
          <!-- .postcontent end -->
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {
      welcome: "This is your profile"
    };
  },
  methods: {
    welcomeMessage() {}
  },
  components: {}
};
</script>
 
<style >
</style>